<template>
  <v-container grid-list-sm fluid>
    <v-layout d-flex wrap v-bind="binding">
      <v-flex sm12 class="pa-2">
        <v-expansion-panels popout v-model="panelActivoEducacion" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header class="title transparent">Educación</v-expansion-panel-header>
            <v-expansion-panel-content class="mt-2">
              <div v-if="editPanelEducacion">
                <div class="d-flex flex-column">
                  <div class="d-flex justify-end">
                    <v-btn dark small color="light-blue darken-2" @click="agregarEducacion">
                      <v-icon left>mdi-plus-circle</v-icon>Agregar
                    </v-btn>
                  </div>
                  <div
                    v-if="educacion.length == 0"
                    class="d-flex justify-center mt-2 text--disabled"
                  >
                    Aquí se agregarán los diferentes niveles de educación que
                    añadas.
                  </div>
                  <v-form ref="formEducacion">
                    <div
                      v-for="(info, index) in educacion"
                      :key="index"
                      class="d-flex pa-2 flex-column blue-grey lighten-5 my-2"
                      style="border-radius: 15px"
                    >
                      <div class="d-flex justify-space-between">
                        <p class="mx-2 my-auto font-weight-bold">{{ index + 1 }}.</p>
                        <v-btn
                          text
                          color="light-blue darken-2"
                          @click="eliminarInfoEducacion(index)"
                        >Eliminar</v-btn>
                      </div>

                      <div class="d-flex justify-space-around">
                        <v-select
                          v-model="educacion[index].tipoEstudio"
                          label="Tipo/Grado de Estudio"
                          :items="gradosEstudio"
                          item-text="titulo"
                          :rules="[rules.required]"
                          item-value="valor"
                          class="mx-2 flex-shrink-1 flex-grow-0"
                        ></v-select>
                        <v-text-field
                          v-model="educacion[index].tituloEstudio"
                          counter="50"
                          label="Título de lo Estudiado"
                          class="mx-2 flex-shrink-0 flex-grow-1"
                        ></v-text-field>
                      </div>
                      <div class="d-flex justify-space-around">
                        <v-text-field
                          v-model="educacion[index].institución"
                          counter="50"
                          label="Institución de Estudio"
                          class="mx-2 flex-shrink-0"
                        ></v-text-field>
                        <v-select
                          v-model="educacion[index].estado"
                          label="Estado de Estudio"
                          :items="estadoEstudio"
                          item-text="titulo"
                          item-value="valor"
                          :rules="[rules.required]"
                          class="mx-2 flex-shrink-1 flex-grow-1"
                        ></v-select>
                      </div>
                      <div class="d-flex justify-space-around mt-2">
                        <v-layout>
                          <v-row>
                            <v-col>
                              <div
                                class="d-flex justify-space-around flex-column blue-grey lighten-4 mx-2 px-2 mt-2"
                                style="border-radius: 15px"
                              >
                                <div class="d-flex font-weight-medium mx-2 my-md-6">Inicio</div>
                                <div class="d-flex flex-shrink-1 flex-grow-1">
                                  <v-select
                                    v-model="educacion[index].inicio.mes"
                                    :items="meses"
                                    item-text="mes"
                                    item-value="valor"
                                    label="Mes de Inicio"
                                    class="mx-2"
                                  ></v-select>
                                  <v-text-field
                                    v-model="educacion[index].inicio.anio"
                                    label="Año de Inicio"
                                    class="mx-2"
                                  ></v-text-field>
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                              <div
                                class="d-flex justify-space-around flex-column blue-grey lighten-4 px-2 mx-2 mt-2"
                                style="border-radius: 15px"
                              >
                                <div class="d-flex justify-space-between align-center">
                                  <div class="d-flex font-weight-medium mx-2">Fin</div>
                                  <v-checkbox
                                    v-model="educacion[index].hastaLaFecha"
                                    label="Hasta la Actualidad"
                                  ></v-checkbox>
                                </div>
                                <div v-if="!educacion[index].hastaLaFecha" class="d-flex">
                                  <v-select
                                    v-model="educacion[index].fin.mes"
                                    :items="meses"
                                    item-text="mes"
                                    item-value="valor"
                                    label="Mes de Fin"
                                    class="mx-2"
                                  ></v-select>
                                  <v-text-field
                                    v-model="educacion[index].fin.anio"
                                    label="Año de Fin"
                                    class="mx-3"
                                  ></v-text-field>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-layout>
                      </div>
                    </div>
                  </v-form>
                </div>
              </div>
              <div v-else class="px-auto px-md-12">
                <div v-if="userData.educacion.length">
                  <v-list-item three-line v-for="(info, index) in userData.educacion" :key="index">
                    <v-list-item-avatar class="my-auto" tile left size="60">
                      <v-icon x-large color="light-blue darken-2">mdi-library</v-icon>
                    </v-list-item-avatar>
                    <v-layout wrap d-flex width="100%">
                      <v-flex xs12 sm6 md6 align-center class="py-auto">
                        <v-list-item-content>
                          <div class="overline">{{ getGradoEstudio(info.tipoEstudio) }}</div>
                          <v-list-item-title
                            class="headline mb-1"
                            style="white-space: initial"
                          >{{ info.tituloEstudio }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{
                            info.institución
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-flex>
                      <v-flex xs12 sm6 md6 align-center class="my-auto">
                        <v-list-item-content>
                          <v-list-item-subtitle class="my-1">
                            Desde
                            {{
                            getFormatoFecha(info.inicio)
                            }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="my-1">
                            Hasta
                            {{
                            info.hastaLaFecha
                            ? 'la Actualidad'
                            : getFormatoFecha(info.fin)
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-flex>
                      <v-divider v-if="userData.educacion.length > 1"></v-divider>
                    </v-layout>
                  </v-list-item>
                </div>
                <div
                  v-else
                  class="d-flex align-center justify-center mt-4 text--disabled"
                >Añade los diferentes tipos de educación que recibiste.</div>
              </div>
              <v-divider class="mt-4"></v-divider>
              <v-card-actions>
                <v-btn
                  v-if="editPanelEducacion"
                  @click="editPanelEducacion = false"
                  :disabled="fetching && editPanelEducacion"
                  text
                >Cancelar</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="actionBtnPanelEducacion"
                  :loading="fetching && editPanelEducacion"
                >
                  <v-icon left color="light-blue darken-2">
                    mdi-{{
                    editPanelEducacion ? 'content-save-edit' : 'plus-circle'
                    }}
                  </v-icon>
                  {{ editPanelEducacion ? 'Guardar' : 'Editar' }}
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['userData'],
  data: function () {
    return {
      panelActivoEducacion: [0],
      editPanelEducacion: false,
      educacion: [],
      gradosEstudio: [
        { titulo: 'Secundario', valor: 'Secundario' },
        { titulo: 'Superior Técnico', valor: 'SuperiorTecnico' },
        { titulo: 'Universitario', valor: 'Universitario' },
        { titulo: 'Posgrado', valor: 'Posgrado' },
        { titulo: 'Master', valor: 'Master' },
        //{titulo: "Otro", valor: "Otro"}
      ],
      estadoEstudio: [
        { titulo: 'En curso', valor: 'En curso' },
        { titulo: 'Completado', valor: 'Completado' },
        { titulo: 'Abandonado/Retirado', valor: 'Abandonado' },
      ],
      meses: [
        { mes: 'Enero', valor: 1 },
        { mes: 'Febrero', valor: 2 },
        { mes: 'Marzo', valor: 3 },
        { mes: 'Abril', valor: 4 },
        { mes: 'Mayo', valor: 5 },
        { mes: 'Junio', valor: 6 },
        { mes: 'Julio', valor: 7 },
        { mes: 'Agosto', valor: 8 },
        { mes: 'Septiembre', valor: 9 },
        { mes: 'Octubre', valor: 10 },
        { mes: 'Noviembre', valor: 11 },
        { mes: 'Diciembre', valor: 12 },
      ],
      rules: {
        required: (value) => !!value || 'Requerido.',
        counter: (value) => value.length <= 50 || 'Max 50 caracteres',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'e-mail Inválido.'
        },
      },
    }
  },
  computed: {
    binding() {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true
      return binding
    },

    ...mapGetters('user', ['fetching']),
  },
  methods: {
    agregarEducacion() {
      let date = new Date()
      this.educacion.push({
        tipoEstudio: '',
        tituloEstudio: '',
        institución: '',
        inicio: {
          mes: date.getMonth(),
          anio: date.getFullYear(),
        },
        fin: {
          mes: date.getMonth(),
          anio: date.getFullYear(),
        },
        hastaLaFecha: false,
        estado: '',
      })
    },

    async actionBtnPanelEducacion() {
      if (this.editPanelEducacion) {
        if (this.$refs.formEducacion.validate()) {
          let body = {
            educacion: this.educacion,
          }
          let response = await this.updateProfileInfo(body)

          if (response && response.success) {
            this.editPanelEducacion = false
            this.userData.educacion = this.cleanSource(this.educacion)
          }
        }
      } else {
        this.educacion = this.cleanSource(this.userData.educacion)
        this.editPanelEducacion = true
      }
    },

    eliminarInfoEducacion(index) {
      this.educacion.splice(index, 1)
    },

    cleanSource(source) {
      // using native JSON functions removes reactivity
      // so we can clone an object without mutating the original source
      return JSON.parse(JSON.stringify(source))
    },

    getFormatoFecha(objetoFecha) {
      let mesValue = this.meses.find((value) => objetoFecha.mes == value.valor)
      return mesValue.mes + ' de ' + objetoFecha.anio
    },

    getGradoEstudio(valor) {
      let gradoEstudio = this.gradosEstudio.find((item) => item.valor == valor)
      return gradoEstudio ? gradoEstudio.titulo : 'No definido'
    },

    ...mapActions('user', ['updateProfileInfo']),
  },
}
</script>

<style>
</style>
